import styled from 'styled-components';
import theme from "../../../../constants/theme";
import {Column, Columns} from "../../../base/grid";

export const CardContainer = styled.div`
	background-color: ${theme.colors.grayLighter};
	padding: 2rem;
	margin-top: 3rem;
	display: flex;
	
	svg {
	    margin-right: 2rem;
	}
	div:last-child {
	    flex: 1;
	    text-align: right;
	}
`;

export const FormWrapper = styled.div`
    background-color: ${theme.colors.grayLighter};
    padding: 2rem;
    margin-top: 3rem;
`;

export const ExpenseWrapper = styled.div`
	border-top: 1px solid ${theme.colors.gray};
	margin-bottom: 1.5rem;
`;

export const BorderColumns = styled(Columns)`
	margin: 0;
	border-bottom: 1px solid ${theme.colors.grayLight};
`;

export const TextColumn = styled(Column)`
	margin-bottom: 0;
    padding: 1rem 2rem;
    font-size: 1.7rem;
    
    ${({right}) => right && `
		text-align: right;
	`}
	
    ${({secondary}) => secondary && `
        font-size: 2.0rem;
		color: ${theme.colors.secondary};
	`}
`;
